import React from 'react';
import styles from './Checkbox.module.scss';
/* Checkbox primitive */ export const Checkbox = ({ checked, onChange, children })=>{
    const handleChange = (newChecked)=>onChange(newChecked);
    return /*#__PURE__*/ React.createElement("div", {
        className: styles.checkbox
    }, /*#__PURE__*/ React.createElement("input", {
        type: "checkbox",
        checked: checked,
        onChange: (e)=>handleChange(e.target.checked)
    }), children != null && /*#__PURE__*/ React.createElement("span", {
        className: styles.label,
        onClick: ()=>handleChange(!checked)
    }, children));
};
